import { GTM_EVENTS } from './constants';

const debounceTimers = Object.create(null);

export const clearDebounceTimers = () => {
  Object.keys(debounceTimers).forEach(key => {
    clearTimeout(debounceTimers[key]);
    delete debounceTimers[key];
  });
};

export const trackComparePrice = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: GTM_EVENTS.FORTELLIS_EVENT,
    event_action: GTM_EVENTS.PC_COMPARE_PRICE
  });
};

export const trackSelectApiVersion = (apiVersion) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: GTM_EVENTS.FORTELLIS_EVENT,
    event_action: GTM_EVENTS.PC_SELECT_API_VERSION,
    api_version: apiVersion || ''
  });
};

export const trackAdjustedCalls = (endpointName, callsPerMonth, apiVersion) => {
  const key = endpointName || 'default';
  if (debounceTimers[key]) {
    clearTimeout(debounceTimers[key]);
  }
  debounceTimers[key] = setTimeout(() => {
    const isAsync = endpointName === GTM_EVENTS.EVENTS_PER_MONTH;
    const payload = {
      event: GTM_EVENTS.FORTELLIS_EVENT,
      event_action: GTM_EVENTS.PC_ADJUSTED_CALLS_PER_MONTH,
      calls_per_month: callsPerMonth != null && callsPerMonth !== '' ? String(callsPerMonth) : null,
      end_point_name: isAsync ? null : (endpointName || null),
      api_version: isAsync ? null : (apiVersion || null)
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    delete debounceTimers[key];
  }, 1000);
};

export const trackRequestInfo = ({ apiName, apiId, apiType }) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: GTM_EVENTS.FORTELLIS_EVENT,
    event_action: GTM_EVENTS.API_INFORMATION_REQUESTED,
    api_name: apiName || '',
    api_id: apiId || '',
    api_type: apiType || 'rest'
  });
};
